/**
 * Created: 2026-02-20
 * Initial commit: Add system test page with error logging mutation
 *
 * Dev-only page for triggering system test mutations.
 */

import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { TestLogErrorDocument, TestRaiseExceptionDocument } from '../gql/graphql'

gql`
  mutation TestLogError {
    testLogError {
      ... on GraphqlSuccess {
        success
      }
      ... on GraphqlRequestError {
        code
        message
      }
    }
  }
`

// Created: 2026-03-18 | Initial commit: Add trigger exception mutation for testing exception logging
gql`
  mutation TestRaiseException {
    testRaiseException {
      ... on GraphqlSuccess {
        success
      }
      ... on GraphqlRequestError {
        code
        message
      }
    }
  }
`

export default function SystemTestPage() {
  const [testLogError, { loading: loadingLog }] = useMutation(TestLogErrorDocument)
  const [testRaiseException, { loading: loadingException }] = useMutation(
    TestRaiseExceptionDocument,
  )

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        System Test
      </Typography>
      <Stack direction="row" spacing={2}>
        <Button
          variant="outlined"
          color="warning"
          disabled={loadingLog}
          onClick={() => testLogError()}
        >
          Trigger Error Log
        </Button>
        <Button
          variant="outlined"
          color="error"
          disabled={loadingException}
          onClick={() => testRaiseException()}
        >
          Trigger Exception
        </Button>
      </Stack>
    </Box>
  )
}
